import { render, staticRenderFns } from "./CompleteRegisterView.vue?vue&type=template&id=26f6a405"
import script from "./CompleteRegisterView.vue?vue&type=script&lang=ts"
export * from "./CompleteRegisterView.vue?vue&type=script&lang=ts"
import style0 from "./CompleteRegisterView.vue?vue&type=style&index=0&id=26f6a405&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports